<template>
  <div class="search">
    <el-form ref="form" :inline="true" :model="form" label-width="100px">
      <el-form-item label="Structure">
        <el-col :span="11">
          <el-input
            type="textarea"
            style="width: 400px"
            :autosize="{ minRows: 2, maxRows: 10 }"
            v-model.trim="form.structure"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Name">
        <el-input v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >Search</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button type="success"  @click="Add"
          >Add</el-button
        >
      </el-form-item>  
    </el-form>
    <el-table
      :data="showData"
      v-loading="loading"
      stripe
      border
      fit
      style="width: 100%"
    >
      <el-table-column type="index"> </el-table-column>
      <el-table-column prop="Inflam_id" label="InflamNat ID">
      </el-table-column>
      <el-table-column prop="Name" label="Name"> </el-table-column>
      <el-table-column prop="SMILES" label="SMILES"> </el-table-column>
      <el-table-column prop="MW" label="Molecular Weight"></el-table-column>
      <el-table-column fixed="right" label="operation">
        <template slot-scope="scope">
          <el-button 
            
            @click="Update(scope.row.id)"
            type="success"
            size="small"
            >Update</el-button
          >
          <el-popconfirm
            title="Are you sure to delete it?？"
            @confirm="Delete(scope.row.id)"
          >
            <el-button
            type="danger"
            size="small"
            style="margin-left:10px"
            slot="reference"
            >Delete</el-button
          >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-warp">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :total="tableData.length"
      />
    </div>
    <!-- <div class="down-load">
      <el-button size="small" @click="down" type="success" round
        >Download</el-button
      >
    </div> -->
    <iframe v-show="false" :src="iframeurl" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  name: "search",
  data() {
    return {
      form: {
        structure: "",
        name: "",
      },
      tableData: [],
      currentNum: 1,
      loading: false,
      fileList: [],
      iframeurl: "",
    };
  },
  computed: {
    showData() {
      let tableList = this.tableData.concat([]);
      return tableList.slice((this.currentNum - 1) * 10, this.currentNum * 10);
    },
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.currentNum = 1;
      this.tableData = [];
      this.$http({
        url: "/api/rdkit/queryBySmiles",
        params: this.form,
        method: "get",
      }).then((res) => {
        this.tableData = res.data.data;
        if (!this.tableData.length) {
          this.$message.warning("No compound matched");
        }
        this.loading = false;
      });
    },
    Add() {
      this.$router.push({
        name: 'upform',
        params:{
          'operate': 'add'
        }
      })
    },
    currentChange(num) {
      this.currentNum = num;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(
      //   `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
      //     files.length + fileList.length
      //   } 个文件`
      // );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Sure to remove ${file.name}？`);
    },
    onSuccess({ data }) {
      this.form.structure = data.join(",");
    },
    down() {
      const { structure, name } = this.form;
      this.iframeurl = `/api/exportCsv?structure=${structure}&name=${name}`;
    },
    Update(id) {
      const { origin, pathname } = window.location;
      this.$router.push({
        path: 'upsmile/upform',
        query:{
          id: id
        }
      })
      // window.open(`${origin}${pathname}#/main/data/upsmile/upform?id=${id}`);
    },
    Delete(id) {
      let self = this
      self.$http({
        url: "",
        methods: "delete",
        params: {
          id: id
        },
      }).then((res) => {
          this.$message({
            message: 'delete successfully',
            type: 'success'
          });
      });
    },
  },
  mounted() {
     this.onSubmit()
  }
};
</script>

<style scoped>
  .page-warp {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .down-load {
    display: flex;
    justify-content: flex-end;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>